import { Input } from "@/components/ui/input";
import { LabelField } from "../ui/label";

export interface TextInputProps {
	readonly value: string;
	readonly onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	readonly errors?: string[];

	readonly label?: string;
	readonly placeholder?: string;
	readonly autoComplete?: string;
	readonly autoCapitalize?: string;
	readonly type?: "text" | "email" | "password" | "tel";
}
export function TextInput(props: TextInputProps) {
	const errors = props.errors ?? [];

	const InputRender = (
		<Input
			value={props.value}
			onChange={props.onChange}
			placeholder={props.placeholder}
			type={props.type ?? "text"}
			style={{
				borderColor: errors.length !== 0 ? "red" : "",
			}}
		/>
	);

	return (
		<div>
			{props.label ? (
				<LabelField label={props.label}>{InputRender}</LabelField>
			) : (
				InputRender
			)}

			{errors.map((error) => (
				<div key={error} style={{ color: "red" }}>
					{error}
				</div>
			))}
		</div>
	);
}
